<div class="row">
    <div class="col-4 mb-1 filter-column" *ngFor="let l of levelCompanies; let i = index">
        <div *ngIf="i==0 || selectedPath[i-1]!=0 && levelCompanies[i].length>0 && selectedChildren[i-1].length>0">
            <button
                [ngClass]="{'btn-primary': selectedCompany=='0'}"
                class="btn btn-outline-primary mt-1 text-left col-12"
                *ngIf="i==0"
                (click)="selectCompany(i,0,false)"
                type="button">
                <i class="far fa-square" *ngIf="selectedCompany!='0'"></i>
                <i class="fas fa-check-square" *ngIf="selectedCompany=='0'"></i>
                All companies
            </button>
            <button class="btn btn-outline-primary mt-1 text-left col-12"
                    [ngClass]="{'btn-primary': excludeDownstream[i-1]}"
                    (click)="selectCompany(i-1, selectedPath[i-1], true)"
                    *ngIf="i!=0"
                    type="button">
                <i class="far fa-square" *ngIf="!excludeDownstream[i-1]"></i>
                <i class="fas fa-check-square" *ngIf="excludeDownstream[i-1]"></i>
                Exclude Downstream
            </button>
            <button *ngFor="let x of levelCompanies[i]"
                    [ngClass]="{'right-arrow': selectedPath[i] == x.companyId && selectedChildren[i].length>0, 'btn-primary': selectedCompany == x.companyId}"
                    class="btn btn-outline-primary mt-1 text-left col-12"
                    (click)="selectCompany(i, x.companyId, false)"
                    [hidden]="i!=0&&selectedPath[i-1]!=x.parentId"
                    type="button">
                <i class="far fa-square" *ngIf="(i==0 && selectedCompany != 0 && selectedCompany != x.companyId) || (i>0 && selectedLevel == i && selectedCompany != x.companyId) || (i>0 && excludeDownstream[i-1]) || (selectedLevel > i)"></i>
                <i class="fas fa-check-square" *ngIf="selectedCompany == x.companyId || (i==0 && selectedCompany==0) || (i>0 && !excludeDownstream[i-1] && (selectedLevel < i))"></i>
                {{x.companyName}}
            </button>
        </div>
    </div>
</div>
